const getDetailTaxesByDateAction = (payload) => ({
  type: 'GET_DETAIL_TAXES_BY_DATE',
  payload,
});

export { getDetailTaxesByDateAction };
